<template>
  <b-modal
    :id="modalId"
    name="move-requirement-modal"
    ref="moverequirementmodal"
    :title="requirements.length > 1 ? `Move ${requirements.length} requirements` : 'Move requirement'"
    size="lg"
    :busy="loading"
    ok-title="Move"
    close-title="Cancel"
    hide-header-close
    :ok-disabled="!selectedFolder"
    @shown="shown"
    @ok="handleOk"
    @cancel="handleCancel">
    <folders-list :folders="folders"></folders-list>
    <span v-if="selectedFolder && requirements.length === 1">This requirement will be moved to <strong>{{ selectedFolder.name }}</strong></span>
    <span v-else-if="selectedFolder && requirements.length > 1"><strong>{{ requirements.length }}</strong> requirements will be moved to <strong>{{ selectedFolder.name }}</strong></span>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Moving
    </div>
  </b-modal>
</template>

<script>
  import FoldersList from '@/components/FoldersList'
  import utilsMixin from '@/mixins/utils'
  export default {
    components: { FoldersList },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      selectedFolder () {
        return this.$store.state.selectedFolder
      }
    },
    data () {
      return {
        folders: [],
        loading: false
      }
    },
    props: {
      modalId: String,
      requirements: Array
    },
    mixins: [utilsMixin],
    methods: {
      clearModal () {
        this.loading = false
        this.$store.commit('setSelectedFolder', null)
      },
      getPrimaryFolders () {
        this.$http.get(
          `/api/folder/primary?atlassian_project_id=${this.currentProject.id}`,
        ).then(response => {
          this.folders = response.data.folders
        }, response => {
          console.log('error')
        })
      },
      handleOk (e) {
        e.preventDefault()
        // Hitting the Move button in the modal
        // This validateAll is needed for the case when nothing has been entered yet
        // Otherwise it was letting it validate
        // The empty then/catch avoids a console error
        this.$validator.validateAll().then(() => {}).catch(() => {})
        if (this.errors.any()) {
          return e.cancel()
        } else {
          this.loading = true
          this.submitData()
        }
      },
      handleCancel (e) {
        this.clearModal()
      },
      shown () {
        this.getPrimaryFolders()
      },
      setTheState () {
        // This potentially updates the name, so both the list and the detail need updating
        this.$store.commit('setNeedToRefreshItemsList', true)
        this.$store.commit('setNeedToRefreshRequirementsDetail', true)
        this.$store.commit('clearSelectedRequirements')
      },
      submitData () {
        this.$ga.event('requirement', 'move', this.requirements.length > 1 ? 'bulk' : 'single', 1)
        this.$http.post(
          '/api/requirement/move/bulk',
          {
            parent_folder_id: this.selectedFolder.folder_id,
            requirements: this.requirements
          }
        ).then(response => {
          window.AP.flag.create({
            title: 'Success!',
            body: this.requirements.length === 1 ? 'Requirement moved successfully' : 'Requirements moved successfully',
            type: 'success',
            close: 'auto'
          })
          this.clearModal()
          this.setTheState()
          this.$refs.moverequirementmodal.hide()
        }, error => {
          let errorString = this.createErrorStringFromResponse(error.response.data)
          let requirementWord = this.requirements.length === 1 ? 'requirement' : 'requirements'
          window.AP.flag.create({
            title: 'Error',
            body: `There was a problem moving your ${requirementWord}: ${errorString}`,
            type: 'error',
            close: 'auto'
          })
          this.loading = false
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MoveRequirementModal.vue?09143014